<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" md="3" lg="3" sm="4" class>
        <p class="google-font mb-0" style="font-size:150%">Was machen wir?</p>
        <p
          class="google-font mt-0"
          style="font-size:95%"
        >Wir sind Informatik-Studenten, die Ihre Erfahrungen, Projekte und Ideen auf dieser Webseite sammeln und bereitstellen.</p>
        <p class="google-font" style="font-size:95%">Unsere Programmiersprachen</p>
        <span v-for="(item,i) in whatwedodata" :key="i">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <a :href="item.link" target="_blank" class="ma-0 mx-3" rel="noreferrer">
                <img :src="getImgUrl(item.image)" width="25vh" alt srcset dark v-on="on" />
              </a>
              &nbsp;&nbsp;&nbsp;
            </template>
            <span>{{item.TechName}}</span>
          </v-tooltip>
        </span>
      </v-col>
      <v-col cols="12" md="9" lg="9" sm="8">
        <v-container fluid>
          <v-row>
            <v-col md="3" lg="3" sm="6" cols="6" class="text-center pa-2">
              <v-icon large style="font-size:300%">mdi-comment</v-icon>
              <p class="google-font mt-2" style="font-size:130%">Networking</p>
              <p
                class="google-font"
                style="font-size:95%"
              >Tausch dich mit uns aus. Networking ist bekanntlich alles.</p>
            </v-col>
            <v-col md="3" lg="3" sm="6" cols="6" class="text-center pa-2">
              <v-icon large style="font-size:300%">mdi-code-tags</v-icon>
              <p class="google-font mt-2" style="font-size:130%">Coding</p>
              <p
                class="google-font"
                style="font-size:95%"
              >Wir lieben Code! Du auch? Dann bist du hier genau richtig.</p>
            </v-col>
            <v-col md="3" lg="3" sm="6" cols="6" class="text-center pa-2">
              <v-icon large style="font-size:300%">mdi-school</v-icon>
              <p class="google-font mt-2" style="font-size:130%">Projekte</p>
              <p
                class="google-font"
                style="font-size:95%"
              >Inspirier dich an unseren Projekten.</p>
            </v-col>
            <v-col md="3" lg="3" sm="6" cols="6" class="text-center pa-2">
              <v-icon large style="font-size:300%">mdi-glasses</v-icon>
              <p class="google-font mt-2" style="font-size:130%">Nerd Talk</p>
              <p
                class="google-font"
                style="font-size:95%"
              >Du redest gerne über Technik und IT, aber niemand hört dir zu? Dann tritt unserer Community bei!</p>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import whatwedodata from "@/assets/data/whatwedo.json";
export default {
  name: "App",
  data: () => ({
    whatwedodata: whatwedodata
  }),
  methods: {
    getImgUrl(url) {
      if (url.length > 0) {
        return require("@/assets/img/what-we-do/" + url);
      } else {
        return require("@/assets/img/what-we-do/notFound.png");
      }
    }
  }
};
</script>